import React from 'react';
import { Table, Form, Row, Col } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { get } from 'lodash';
import { JSON_KEYS, PROJECTS_TABLE_HEADERS_ARRAY } from '../../constants';
import SVG_CLASS_NAME from '../../constants/style';
import { convertUnits, getSvgFaIcon } from '../../utils/common';
import ICONS  from '../../images/items';

import './index.css';

const ProjectsTable = ({
  headers,
  rows,
  changeSort,
  sort,
  selectedProjects,
  selectProject,
  deselectProject,
  selectAllProjects,
  deselectAllProjects,
  sortMethod,
  sortMethods,
  setSortMethod,
}) => {
  const handleSelection = (project, checked) => {
    if (checked) {
      selectProject(project);
    }
    else {
      deselectProject(project);
    }
  };

  const handleAllSelection = checked => {
    if (checked) {
      selectAllProjects();
    }
    else {
      deselectAllProjects();
    }
  };

  const statusIconFormatter = (key, value) => {
    switch (key) {
      case 'status':
        return (
          <Row>
            <Col className="mr-2" md="1">
              <span title={`${value[key]}`} className="fa-stack icon">
                <svg
                  title={`${value[key]}`}
                  className={`svg-inline--fa fa-stack-1x icon ${SVG_CLASS_NAME[getSvgFaIcon(value[key])]}`}
                  aria-labelledby="svg-inline--fa-title-1"
                  data-prefix="fas"
                  data-icon={getSvgFaIcon(value[key])}
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  data-fa-i2svg=""
                  viewBox={ICONS[getSvgFaIcon(value[key])]['viewBox']}
                  fill={ICONS[getSvgFaIcon(value[key])]['fill']}
                >
                  <title id="svg-inline--fa-title-1">{value[key]}</title>
                  {ICONS[getSvgFaIcon(value[key])]['paths'][0]}
                </svg>
                {value[key] === 'Edited_After_Review' &&
                  <svg
                    title={`${value[key]}`}
                    className={`svg-inline--fa fa-stack-1x fa-flip-horizontal icon ${SVG_CLASS_NAME['pen']}`}
                    aria-labelledby="svg-inline--fa-title-1"
                    data-prefix="fas"
                    data-icon='pen'
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    data-fa-i2svg=""
                    viewBox={ICONS[getSvgFaIcon(value[key])]['viewBox']}
                    fill={ICONS[getSvgFaIcon(value[key])]['fill']}
                  >
                    {ICONS['pen']['paths'][0]}
                  </svg>
                }
              </span>
            </Col>

            <Col>
              {value[key]}
            </Col>
          </Row>
        );
      case 'disk_usage':
        return convertUnits(value.sidekick[key]);
      default:
        return value[key];
    }
  };

  return (
    <Table striped bordered hover className="fixed_headers_projects_table">
      <thead>
        <tr>
          <th key='checkbox'>
            <Form.Check
              className="checkbox"
              onClick={e => handleAllSelection(e.target.checked)}
            />
          </th>
          <th key="order">
            #
          </th>
          {headers.map((header, i) => {
            if (get(sortMethods, PROJECTS_TABLE_HEADERS_ARRAY[i])) {
              const isSortingOn = sortMethod.toString() === sortMethods[PROJECTS_TABLE_HEADERS_ARRAY[i]].toString();
              const sortingIcon = sort === "ascending" ? "arrow-down" : "arrow-up";
              const finalIcon = isSortingOn ? sortingIcon : "minus";

              return (<th key={PROJECTS_TABLE_HEADERS_ARRAY[i]}>
                {header} <FontAwesome
                  className="sortArrow"
                  onClick={() => {
                    changeSort();
                    setSortMethod(() => sortMethods[PROJECTS_TABLE_HEADERS_ARRAY[i]]);
                  }}
                  name={finalIcon}
                />
              </th>);
            }
            return <th key={PROJECTS_TABLE_HEADERS_ARRAY[i]}>{header}</th>
          })}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, idx) => (
          <tr key={row[JSON_KEYS.PATH]}>
            <td>
              <Form.Check
                className="checkbox"
                checked={!!selectedProjects.find(selectedProject => selectedProject.path === row.path)}
                onChange={e => handleSelection(row, e.target.checked)}
              />
            </td>
            <td>{idx+1}</td>
            {PROJECTS_TABLE_HEADERS_ARRAY.map(key =>
              <td key={`${row.path}${key}`}>
                {statusIconFormatter(key, row)}
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default ProjectsTable;
